import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { invalidateScoutingData } from "@/lib/scoutingDataInvalidation";

/** Por qué se cierra un foco (D14). «Alguien ha ido y está limpio» no es un motivo: es una revisión limpia (`clean_check`). */
export type FocusCloseReason = "treated" | "mistake" | "other";

export type PestFocusAction =
  /** `cancel_tasks`: quien cierra ha dicho que sí a anular lo que el foco tenía por hacer (E, 23-09-2026). */
  | { action: "close"; focus_id: string; reason?: FocusCloseReason; notes?: string; cancel_tasks?: boolean }
  | { action: "reopen"; focus_id: string }
  | { action: "correct_pest"; focus_id: string; pest_id: string }
  | { action: "merge"; focus_id: string; target_focus_id: string; adopt_target_pest?: boolean }
  | { action: "split"; focus_id: string; session_ids: string[] }
  | { action: "clean_check"; focus_id: string; session_id?: string; close_focus?: boolean; notes?: string; cancel_tasks?: boolean };

/**
 * Las acciones sobre un foco ENTERO: cerrar, reabrir, corregir la plaga, unir,
 * separar y registrar una revisión limpia. Una sola RPC (`pest_focus_action`),
 * que valida rol y alcance en la base de datos; aquí solo se llama y se avisa a
 * todo lo que lee partes.
 */
export function usePestFocusAction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: PestFocusAction) => {
      const { data, error } = await supabase.rpc("pest_focus_action", { p_payload: payload });
      if (error) throw error;
      return data as { focus_id: string | null; new_focus_id: string | null; session_id: string | null; affected: number };
    },
    onSettled: () => invalidateScoutingData(queryClient),
  });
}
